import { render } from "./OurServices.vue?vue&type=template&id=4e2b8687&scoped=true"
const script = {}

import "./OurServices.vue?vue&type=style&index=0&id=4e2b8687&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2b8687"]])

export default __exports__